export default {
  production_plan_status: {
    pending: 1,
    in_progress: 2,
    released: 3,
    cancelled: 4,
    rejected: 5,
  },
};